import { ClientSwitchButton } from '../../gameClient/clientSwitchButton';

type SetClientTypeSwitchButtonStateParams = {
    visible: boolean,
    text: string
};

export class SetClientTypeSwitchButtonState {
    public handle(params: SetClientTypeSwitchButtonStateParams): void {
        ClientSwitchButton.setState(params.visible, params.text);
    }
}
